import PropTypes from 'prop-types';
import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';

export default function TitleCasedTextField({ name, rules, helperText, ...other }) {
  const { control } = useFormContext();
  const inputRef = useRef(null);

  // Keep title case logic, applies to every word
  const titleCase = (text) =>
    text.replace(/\w\S*/g, (word) =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );

  // Handle typing: do NOT trim here
  const handleChange = (event, field) => {
    const input = event.target;
    const originalSelectionStart = input.selectionStart;
    const originalSelectionEnd = input.selectionEnd;

    // Keep exact input, only apply title case
    const titleCasedValue = titleCase(input.value);

    field.onChange(titleCasedValue);

    // Restore cursor
    setTimeout(() => {
      input.setSelectionRange(originalSelectionStart, originalSelectionEnd);
    }, 0);
  };

  // Handle blur: trim leading/trailing spaces
  const handleBlur = (event, field) => {
    const trimmedValue = (field.value || '').trim();
    if (trimmedValue !== field.value) {
      field.onChange(trimmedValue);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          inputRef={inputRef}
          fullWidth
          value={field.value || ''}
          onChange={(event) => handleChange(event, field)}
          onBlur={(event) => handleBlur(event, field)}
          error={!!error}
          helperText={error ? error.message : helperText}
          {...other}
        />
      )}
    />
  );
}

TitleCasedTextField.propTypes = {
  helperText: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
};

// this code commented becuase it having core logic about the Title case and trim the spaces in the text field, if we need to use this component in future we can uncomment this code and use it.

// import PropTypes from 'prop-types';
// import { useState } from 'react';
// import { Controller, useFormContext } from 'react-hook-form';
// import { TextField } from '@mui/material';

// export default function TitleCasedTextField({ name, helperText, ...other }) {
//   const { control } = useFormContext();

//   const titleCase = (text) =>
//     text
//       .toLowerCase()
//       .split(' ')
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(' ');

//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field, fieldState: { error } }) => (
//         <TextField
//           {...field}
//           fullWidth
//           value={field.value}
//           onChange={(event) => {
//             const inputValue = event.target.value;
//             const titleCasedValue = titleCase(inputValue);
//             field.onChange(titleCasedValue);
//           }}
//           error={!!error}
//           helperText={error ? error.message : helperText}
//           {...other}
//         />
//       )}
//     />
//   );
// }

// TitleCasedTextField.propTypes = {
//   helperText: PropTypes.string,
//   name: PropTypes.string,
// };
